import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { X } from 'lucide-react';
import { forwardRef, useState } from 'react';
import { cn } from "../lib/cn.js";
export const TagInput = forwardRef(({ value, onValueChange, id, placeholder, disabled = false, invalid = false, className, ...aria }, ref) => {
    const [draft, setDraft] = useState('');
    const commit = (raw) => {
        const additions = raw
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item !== '' && !value.includes(item));
        if (additions.length > 0)
            onValueChange([...value, ...additions]);
        setDraft('');
    };
    const removeAt = (index) => {
        onValueChange(value.filter((_, i) => i !== index));
    };
    const onKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ',') {
            if (draft.trim() === '')
                return;
            event.preventDefault();
            commit(draft);
            return;
        }
        if (event.key === 'Backspace' && draft === '' && value.length > 0) {
            removeAt(value.length - 1);
        }
    };
    return (_jsxs("div", { className: cn('flex min-h-(--control-height-md) w-full flex-wrap items-center gap-1.5 rounded-(--radius-md) px-2 py-1', 'bg-(--surface) border border-(--border-default)', 'transition-colors duration-(--duration-fast)', 
        /*
         * Contorno de 2px, igual ao `Combobox` — não só a cor da borda.
         *
         * O `<input>` aqui dentro leva `outline-none`, e essa classe vence a
         * regra global de `:focus-visible` do `base.css` por vir depois na
         * cascata. Ou seja: o anel de foco do produto inteiro **não** aparece
         * neste campo, e o que sobrava era a borda de 1px trocando de cor.
         *
         * Cor sozinha é o sinal que passa na revisão e some no monitor
         * lavado do balcão — `docs/UI_UX.md` proíbe justamente isso. E os
         * dois primitivos irmãos que têm o mesmo problema (`Combobox` e
         * `MoneyInput`) já resolviam com contorno; este era o único fora de
         * compasso.
         */
        'focus-within:outline focus-within:outline-2 focus-within:outline-(--border-focus)', 'hover:border-(--border-strong)', disabled ? 'cursor-not-allowed bg-(--surface-sunken) opacity-60' : '', invalid ? 'border-(--danger)' : '', className), children: [value.map((item, index) => (_jsxs("span", { className: cn('inline-flex items-center gap-1 rounded-(--radius-sm) py-0.5 pl-2 pr-1', 'bg-(--surface-sunken) text-(length:--text-xs) text-(--text-primary)'), children: [item, disabled ? null : (_jsx("button", { type: "button", "aria-label": `Remover ${item}`, onClick: () => {
                            removeAt(index);
                        }, className: cn('rounded-(--radius-full) p-0.5 text-(--text-muted)', 'hover:bg-(--surface-hover) hover:text-(--text-primary)'), children: _jsx(X, { "aria-hidden": "true", className: "h-3 w-3" }) }))] }, item))), _jsx("input", { ref: ref, id: id, type: "text", disabled: disabled, "aria-invalid": invalid || undefined, "aria-describedby": aria['aria-describedby'], value: draft, placeholder: value.length === 0 ? placeholder : undefined, onChange: (event) => {
                    setDraft(event.target.value);
                }, onKeyDown: onKeyDown, onBlur: () => {
                    if (draft.trim() !== '')
                        commit(draft);
                }, className: cn('h-6 min-w-16 flex-1 border-0 bg-transparent p-0 outline-none', 'text-(length:--text-sm) text-(--text-primary)', 'placeholder:text-(--text-muted) disabled:cursor-not-allowed') })] }));
});
TagInput.displayName = 'TagInput';
//# sourceMappingURL=tag-input.js.map